var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadEclip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0872 12.2852C22.6011 11.8203 23.4342 11.8203 23.948 12.2852C24.4619 12.7501 24.4619 13.5039 23.948 13.9688L16.9305 20.318C16.4166 20.7829 15.5835 20.7829 15.0697 20.318L8.05213 13.9688C7.53829 13.5039 7.53829 12.7501 8.05213 12.2852C8.56598 11.8203 9.39909 11.8203 9.91294 12.2852L14.6843 16.6021V4.71429C14.6843 4.3198 15.2734 4 16 4C16.7267 4 17.3158 4.3198 17.3158 4.71429V16.6022L22.0872 12.2852ZM4.33341 25.6667H27.6667C28.5872 25.6667 29.3334 26.3299 29.3334 27.1481C29.3334 27.9663 28.5872 28.6296 27.6667 28.6296H4.33341C3.41294 28.6296 2.66675 27.9663 2.66675 27.1481C2.66675 26.3299 3.41294 25.6667 4.33341 25.6667Z",
    fill: "#BE5400"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadEclip);
export default __webpack_public_path__ + "static/media/download-eclip.e2192048cab279a031b910f7947ebbcd.svg";
export { ForwardRef as ReactComponent };